export enum ReferentialCode {
  DIGITAL_SKILLS = 'digital_skills',
  CAIL = 'critical_ai',
}
